<script>
export default {
  name: "vnode",
  props: {
    content: {
      type: [Object, Array, Function, String, Number],
      required: true
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  render(h) {
    if (!this.content)
      return null;
    let content = this.content;
    if (typeof content === "number")
      content = "" + content;
    if (typeof content === "string")
      return this.$createElement(this.tag, content);
    if (Array.isArray(this.content) && this.content.length !== 1) {
      console.error("content 只能包含一个节点");
      content = this.content[0];
    }
    return typeof content === "function" ? content(h) : content;
  }
};

</script>
